module.exports = __webpack_public_path__ + "img/logo-white.042b2b15.png";